/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/client";
import type { GetDownloadDatasheetsUrlQueryResponse, GetDownloadDatasheetsUrlPathParams, GetDownloadDatasheetsUrlQueryParams, GetDownloadDatasheetsUrl400 } from "../../models/GetDownloadDatasheetsUrl";
import type { RequestConfig, ResponseErrorConfig } from "@/client";

function getGetDownloadDatasheetsUrlUrl({ productCode }: { productCode: GetDownloadDatasheetsUrlPathParams["productCode"] }) {
  const res = { method: 'GET', url: `/api/v1/products/${productCode}/datasheets-url` as const }  
  return res
}

/**
 * {@link /api/v1/products/:productCode/datasheets-url}
 */
export async function getDownloadDatasheetsUrl({ productCode, params }: { productCode: GetDownloadDatasheetsUrlPathParams["productCode"]; params: GetDownloadDatasheetsUrlQueryParams }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetDownloadDatasheetsUrlQueryResponse, ResponseErrorConfig<GetDownloadDatasheetsUrl400>, unknown>({ method : "GET", url : getGetDownloadDatasheetsUrlUrl({ productCode }).url.toString(), params, ... requestConfig })  
  return res.data
}